export const data = [
  {
    id: 1,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
  {
    id: 2,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
  {
    id: 3,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
  {
    id: 4,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
  {
    id: 5,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
  {
    id: 6,
    title: "Ansan",
    rutitle: "Ansan",
    moljal: "Ansan Station",
    ish: "9:00 - 20:00",
  },
];
